const SNACKBAR_TYPE = Object.freeze({
  SUCCESS: 'SUCCESS',
  DANGER: 'DANGER',
  WARNING: 'WARNING'
});

export { SNACKBAR_TYPE };
